// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.0
//   protoc               v3.20.3
// source: darwin_agent.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { DarwinHeader, ReasoningEffortLevel, reasoningEffortLevelFromJSON, reasoningEffortLevelToJSON } from "./common";

export const protobufPackage = "com.anko.darwin";

export enum DarwinToolType {
  UNKNOWN_TOOL_TYPE = 0,
  AGENT_TOOL = 1,
  ADD_NUMBERS = 2,
  KG_OBSERVATION_DATA = 3,
  GET_NODES_DATA = 4,
  DATAFRAME_TOOL = 5,
  RESPONSE_TOOL = 6,
  GET_ATTRIBUTE_VALUES = 7,
  GET_PAST_JOB_RUNS = 8,
  UPDATE_SCENARIO_METADATA_TOOL = 9,
  SAVE_SCENARIO_TOOL = 10,
  GET_SCENARIO_DETAIL_TOOL = 11,
  SKILL_TOOL = 12,
  BUILD_ANALYSIS_OUTPUT_TOOL = 13,
  ANALYZE_DATAFRAMES_TOOL = 14,
  LOAD_SKILL_TOOL = 15,
  UNRECOGNIZED = -1,
}

export function darwinToolTypeFromJSON(object: any): DarwinToolType {
  switch (object) {
    case 0:
    case "UNKNOWN_TOOL_TYPE":
      return DarwinToolType.UNKNOWN_TOOL_TYPE;
    case 1:
    case "AGENT_TOOL":
      return DarwinToolType.AGENT_TOOL;
    case 2:
    case "ADD_NUMBERS":
      return DarwinToolType.ADD_NUMBERS;
    case 3:
    case "KG_OBSERVATION_DATA":
      return DarwinToolType.KG_OBSERVATION_DATA;
    case 4:
    case "GET_NODES_DATA":
      return DarwinToolType.GET_NODES_DATA;
    case 5:
    case "DATAFRAME_TOOL":
      return DarwinToolType.DATAFRAME_TOOL;
    case 6:
    case "RESPONSE_TOOL":
      return DarwinToolType.RESPONSE_TOOL;
    case 7:
    case "GET_ATTRIBUTE_VALUES":
      return DarwinToolType.GET_ATTRIBUTE_VALUES;
    case 8:
    case "GET_PAST_JOB_RUNS":
      return DarwinToolType.GET_PAST_JOB_RUNS;
    case 9:
    case "UPDATE_SCENARIO_METADATA_TOOL":
      return DarwinToolType.UPDATE_SCENARIO_METADATA_TOOL;
    case 10:
    case "SAVE_SCENARIO_TOOL":
      return DarwinToolType.SAVE_SCENARIO_TOOL;
    case 11:
    case "GET_SCENARIO_DETAIL_TOOL":
      return DarwinToolType.GET_SCENARIO_DETAIL_TOOL;
    case 12:
    case "SKILL_TOOL":
      return DarwinToolType.SKILL_TOOL;
    case 13:
    case "BUILD_ANALYSIS_OUTPUT_TOOL":
      return DarwinToolType.BUILD_ANALYSIS_OUTPUT_TOOL;
    case 14:
    case "ANALYZE_DATAFRAMES_TOOL":
      return DarwinToolType.ANALYZE_DATAFRAMES_TOOL;
    case 15:
    case "LOAD_SKILL_TOOL":
      return DarwinToolType.LOAD_SKILL_TOOL;
    case -1:
    case "UNRECOGNIZED":
    default:
      return DarwinToolType.UNRECOGNIZED;
  }
}

export function darwinToolTypeToJSON(object: DarwinToolType): string {
  switch (object) {
    case DarwinToolType.UNKNOWN_TOOL_TYPE:
      return "UNKNOWN_TOOL_TYPE";
    case DarwinToolType.AGENT_TOOL:
      return "AGENT_TOOL";
    case DarwinToolType.ADD_NUMBERS:
      return "ADD_NUMBERS";
    case DarwinToolType.KG_OBSERVATION_DATA:
      return "KG_OBSERVATION_DATA";
    case DarwinToolType.GET_NODES_DATA:
      return "GET_NODES_DATA";
    case DarwinToolType.DATAFRAME_TOOL:
      return "DATAFRAME_TOOL";
    case DarwinToolType.RESPONSE_TOOL:
      return "RESPONSE_TOOL";
    case DarwinToolType.GET_ATTRIBUTE_VALUES:
      return "GET_ATTRIBUTE_VALUES";
    case DarwinToolType.GET_PAST_JOB_RUNS:
      return "GET_PAST_JOB_RUNS";
    case DarwinToolType.UPDATE_SCENARIO_METADATA_TOOL:
      return "UPDATE_SCENARIO_METADATA_TOOL";
    case DarwinToolType.SAVE_SCENARIO_TOOL:
      return "SAVE_SCENARIO_TOOL";
    case DarwinToolType.GET_SCENARIO_DETAIL_TOOL:
      return "GET_SCENARIO_DETAIL_TOOL";
    case DarwinToolType.SKILL_TOOL:
      return "SKILL_TOOL";
    case DarwinToolType.BUILD_ANALYSIS_OUTPUT_TOOL:
      return "BUILD_ANALYSIS_OUTPUT_TOOL";
    case DarwinToolType.ANALYZE_DATAFRAMES_TOOL:
      return "ANALYZE_DATAFRAMES_TOOL";
    case DarwinToolType.LOAD_SKILL_TOOL:
      return "LOAD_SKILL_TOOL";
    case DarwinToolType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum ArgsSchemaType {
  UNKNOWN_SCHEMA_TYPE = 0,
  GET_NODES_DATA_SCHEMA = 3,
  KG_OBSERVATION_DATA_SCHEMA_V1 = 4,
  KG_OBSERVATION_DATA_SCHEMA_V2 = 5,
  KG_OBSERVATION_DATA_SCHEMA_V3 = 6,
  DATAFRAME_TOOL_SCHEMA = 7,
  DATAFRAME_TOOL_SCHEMA_V1 = 8,
  DATAFRAME_TOOL_SCHEMA_V2 = 9,
  DATAFRAME_TOOL_SCHEMA_V3 = 10,
  DATA_SCOPE_AGENT_TOOL_SCHEMA_V1 = 11,
  DATA_SCOPE_AGENT_TOOL_SCHEMA_V2 = 12,
  SCENARIO_AGENT_TOOL_SCHEMA = 13,
  SCENARIO_AGENT_RESPONSE_TOOL_SCHEMA = 14,
  SCENARIO_SYNTHESIS_AGENT_RESPONSE_TOOL_SCHEMA = 15,
  GET_ATTRIBUTE_VALUES_SCHEMA = 16,
  DATAFRAME_TOOL_SCHEMA_V4 = 17,
  GET_PAST_JOB_RUNS_TOOL_SCHEMA = 18,
  GET_PAST_JOB_RUNS_TOOL_SCHEMA_V1 = 19,
  UPDATE_SCENARIO_METADATA_TOOL_SCHEMA = 20,
  SAVE_SCENARIO_TOOL_SCHEMA = 21,
  GET_SCENARIO_DETAIL_TOOL_SCHEMA = 22,
  SCENARIO_SYNTHESIS_AGENT_RESPONSE_TOOL_SCHEMA_V1 = 23,
  SCENARIO_MANAGEMENT_SKILL_SCHEMA = 24,
  SCENARIO_SYNTHESIS_SKILL_TOOL_SCHEMA = 25,
  BUILD_ANALYSIS_OUTPUT_TOOL_SCHEMA = 26,
  GET_ANALYSIS_OUTPUT_TOOL_SCHEMA = 27,
  ANALYZE_DATAFRAMES_TOOL_SCHEMA = 28,
  DATAFRAME_TOOL_SCHEMA_V5 = 29,
  SKILL_TOOL_SCHEMA = 30,
  DATAFRAME_TOOL_SCHEMA_V6 = 31,
  DATAFRAME_TOOL_SCHEMA_V7 = 32,
  UNRECOGNIZED = -1,
}

export function argsSchemaTypeFromJSON(object: any): ArgsSchemaType {
  switch (object) {
    case 0:
    case "UNKNOWN_SCHEMA_TYPE":
      return ArgsSchemaType.UNKNOWN_SCHEMA_TYPE;
    case 3:
    case "GET_NODES_DATA_SCHEMA":
      return ArgsSchemaType.GET_NODES_DATA_SCHEMA;
    case 4:
    case "KG_OBSERVATION_DATA_SCHEMA_V1":
      return ArgsSchemaType.KG_OBSERVATION_DATA_SCHEMA_V1;
    case 5:
    case "KG_OBSERVATION_DATA_SCHEMA_V2":
      return ArgsSchemaType.KG_OBSERVATION_DATA_SCHEMA_V2;
    case 6:
    case "KG_OBSERVATION_DATA_SCHEMA_V3":
      return ArgsSchemaType.KG_OBSERVATION_DATA_SCHEMA_V3;
    case 7:
    case "DATAFRAME_TOOL_SCHEMA":
      return ArgsSchemaType.DATAFRAME_TOOL_SCHEMA;
    case 8:
    case "DATAFRAME_TOOL_SCHEMA_V1":
      return ArgsSchemaType.DATAFRAME_TOOL_SCHEMA_V1;
    case 9:
    case "DATAFRAME_TOOL_SCHEMA_V2":
      return ArgsSchemaType.DATAFRAME_TOOL_SCHEMA_V2;
    case 10:
    case "DATAFRAME_TOOL_SCHEMA_V3":
      return ArgsSchemaType.DATAFRAME_TOOL_SCHEMA_V3;
    case 11:
    case "DATA_SCOPE_AGENT_TOOL_SCHEMA_V1":
      return ArgsSchemaType.DATA_SCOPE_AGENT_TOOL_SCHEMA_V1;
    case 12:
    case "DATA_SCOPE_AGENT_TOOL_SCHEMA_V2":
      return ArgsSchemaType.DATA_SCOPE_AGENT_TOOL_SCHEMA_V2;
    case 13:
    case "SCENARIO_AGENT_TOOL_SCHEMA":
      return ArgsSchemaType.SCENARIO_AGENT_TOOL_SCHEMA;
    case 14:
    case "SCENARIO_AGENT_RESPONSE_TOOL_SCHEMA":
      return ArgsSchemaType.SCENARIO_AGENT_RESPONSE_TOOL_SCHEMA;
    case 15:
    case "SCENARIO_SYNTHESIS_AGENT_RESPONSE_TOOL_SCHEMA":
      return ArgsSchemaType.SCENARIO_SYNTHESIS_AGENT_RESPONSE_TOOL_SCHEMA;
    case 16:
    case "GET_ATTRIBUTE_VALUES_SCHEMA":
      return ArgsSchemaType.GET_ATTRIBUTE_VALUES_SCHEMA;
    case 17:
    case "DATAFRAME_TOOL_SCHEMA_V4":
      return ArgsSchemaType.DATAFRAME_TOOL_SCHEMA_V4;
    case 18:
    case "GET_PAST_JOB_RUNS_TOOL_SCHEMA":
      return ArgsSchemaType.GET_PAST_JOB_RUNS_TOOL_SCHEMA;
    case 19:
    case "GET_PAST_JOB_RUNS_TOOL_SCHEMA_V1":
      return ArgsSchemaType.GET_PAST_JOB_RUNS_TOOL_SCHEMA_V1;
    case 20:
    case "UPDATE_SCENARIO_METADATA_TOOL_SCHEMA":
      return ArgsSchemaType.UPDATE_SCENARIO_METADATA_TOOL_SCHEMA;
    case 21:
    case "SAVE_SCENARIO_TOOL_SCHEMA":
      return ArgsSchemaType.SAVE_SCENARIO_TOOL_SCHEMA;
    case 22:
    case "GET_SCENARIO_DETAIL_TOOL_SCHEMA":
      return ArgsSchemaType.GET_SCENARIO_DETAIL_TOOL_SCHEMA;
    case 23:
    case "SCENARIO_SYNTHESIS_AGENT_RESPONSE_TOOL_SCHEMA_V1":
      return ArgsSchemaType.SCENARIO_SYNTHESIS_AGENT_RESPONSE_TOOL_SCHEMA_V1;
    case 24:
    case "SCENARIO_MANAGEMENT_SKILL_SCHEMA":
      return ArgsSchemaType.SCENARIO_MANAGEMENT_SKILL_SCHEMA;
    case 25:
    case "SCENARIO_SYNTHESIS_SKILL_TOOL_SCHEMA":
      return ArgsSchemaType.SCENARIO_SYNTHESIS_SKILL_TOOL_SCHEMA;
    case 26:
    case "BUILD_ANALYSIS_OUTPUT_TOOL_SCHEMA":
      return ArgsSchemaType.BUILD_ANALYSIS_OUTPUT_TOOL_SCHEMA;
    case 27:
    case "GET_ANALYSIS_OUTPUT_TOOL_SCHEMA":
      return ArgsSchemaType.GET_ANALYSIS_OUTPUT_TOOL_SCHEMA;
    case 28:
    case "ANALYZE_DATAFRAMES_TOOL_SCHEMA":
      return ArgsSchemaType.ANALYZE_DATAFRAMES_TOOL_SCHEMA;
    case 29:
    case "DATAFRAME_TOOL_SCHEMA_V5":
      return ArgsSchemaType.DATAFRAME_TOOL_SCHEMA_V5;
    case 30:
    case "SKILL_TOOL_SCHEMA":
      return ArgsSchemaType.SKILL_TOOL_SCHEMA;
    case 31:
    case "DATAFRAME_TOOL_SCHEMA_V6":
      return ArgsSchemaType.DATAFRAME_TOOL_SCHEMA_V6;
    case 32:
    case "DATAFRAME_TOOL_SCHEMA_V7":
      return ArgsSchemaType.DATAFRAME_TOOL_SCHEMA_V7;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ArgsSchemaType.UNRECOGNIZED;
  }
}

export function argsSchemaTypeToJSON(object: ArgsSchemaType): string {
  switch (object) {
    case ArgsSchemaType.UNKNOWN_SCHEMA_TYPE:
      return "UNKNOWN_SCHEMA_TYPE";
    case ArgsSchemaType.GET_NODES_DATA_SCHEMA:
      return "GET_NODES_DATA_SCHEMA";
    case ArgsSchemaType.KG_OBSERVATION_DATA_SCHEMA_V1:
      return "KG_OBSERVATION_DATA_SCHEMA_V1";
    case ArgsSchemaType.KG_OBSERVATION_DATA_SCHEMA_V2:
      return "KG_OBSERVATION_DATA_SCHEMA_V2";
    case ArgsSchemaType.KG_OBSERVATION_DATA_SCHEMA_V3:
      return "KG_OBSERVATION_DATA_SCHEMA_V3";
    case ArgsSchemaType.DATAFRAME_TOOL_SCHEMA:
      return "DATAFRAME_TOOL_SCHEMA";
    case ArgsSchemaType.DATAFRAME_TOOL_SCHEMA_V1:
      return "DATAFRAME_TOOL_SCHEMA_V1";
    case ArgsSchemaType.DATAFRAME_TOOL_SCHEMA_V2:
      return "DATAFRAME_TOOL_SCHEMA_V2";
    case ArgsSchemaType.DATAFRAME_TOOL_SCHEMA_V3:
      return "DATAFRAME_TOOL_SCHEMA_V3";
    case ArgsSchemaType.DATA_SCOPE_AGENT_TOOL_SCHEMA_V1:
      return "DATA_SCOPE_AGENT_TOOL_SCHEMA_V1";
    case ArgsSchemaType.DATA_SCOPE_AGENT_TOOL_SCHEMA_V2:
      return "DATA_SCOPE_AGENT_TOOL_SCHEMA_V2";
    case ArgsSchemaType.SCENARIO_AGENT_TOOL_SCHEMA:
      return "SCENARIO_AGENT_TOOL_SCHEMA";
    case ArgsSchemaType.SCENARIO_AGENT_RESPONSE_TOOL_SCHEMA:
      return "SCENARIO_AGENT_RESPONSE_TOOL_SCHEMA";
    case ArgsSchemaType.SCENARIO_SYNTHESIS_AGENT_RESPONSE_TOOL_SCHEMA:
      return "SCENARIO_SYNTHESIS_AGENT_RESPONSE_TOOL_SCHEMA";
    case ArgsSchemaType.GET_ATTRIBUTE_VALUES_SCHEMA:
      return "GET_ATTRIBUTE_VALUES_SCHEMA";
    case ArgsSchemaType.DATAFRAME_TOOL_SCHEMA_V4:
      return "DATAFRAME_TOOL_SCHEMA_V4";
    case ArgsSchemaType.GET_PAST_JOB_RUNS_TOOL_SCHEMA:
      return "GET_PAST_JOB_RUNS_TOOL_SCHEMA";
    case ArgsSchemaType.GET_PAST_JOB_RUNS_TOOL_SCHEMA_V1:
      return "GET_PAST_JOB_RUNS_TOOL_SCHEMA_V1";
    case ArgsSchemaType.UPDATE_SCENARIO_METADATA_TOOL_SCHEMA:
      return "UPDATE_SCENARIO_METADATA_TOOL_SCHEMA";
    case ArgsSchemaType.SAVE_SCENARIO_TOOL_SCHEMA:
      return "SAVE_SCENARIO_TOOL_SCHEMA";
    case ArgsSchemaType.GET_SCENARIO_DETAIL_TOOL_SCHEMA:
      return "GET_SCENARIO_DETAIL_TOOL_SCHEMA";
    case ArgsSchemaType.SCENARIO_SYNTHESIS_AGENT_RESPONSE_TOOL_SCHEMA_V1:
      return "SCENARIO_SYNTHESIS_AGENT_RESPONSE_TOOL_SCHEMA_V1";
    case ArgsSchemaType.SCENARIO_MANAGEMENT_SKILL_SCHEMA:
      return "SCENARIO_MANAGEMENT_SKILL_SCHEMA";
    case ArgsSchemaType.SCENARIO_SYNTHESIS_SKILL_TOOL_SCHEMA:
      return "SCENARIO_SYNTHESIS_SKILL_TOOL_SCHEMA";
    case ArgsSchemaType.BUILD_ANALYSIS_OUTPUT_TOOL_SCHEMA:
      return "BUILD_ANALYSIS_OUTPUT_TOOL_SCHEMA";
    case ArgsSchemaType.GET_ANALYSIS_OUTPUT_TOOL_SCHEMA:
      return "GET_ANALYSIS_OUTPUT_TOOL_SCHEMA";
    case ArgsSchemaType.ANALYZE_DATAFRAMES_TOOL_SCHEMA:
      return "ANALYZE_DATAFRAMES_TOOL_SCHEMA";
    case ArgsSchemaType.DATAFRAME_TOOL_SCHEMA_V5:
      return "DATAFRAME_TOOL_SCHEMA_V5";
    case ArgsSchemaType.SKILL_TOOL_SCHEMA:
      return "SKILL_TOOL_SCHEMA";
    case ArgsSchemaType.DATAFRAME_TOOL_SCHEMA_V6:
      return "DATAFRAME_TOOL_SCHEMA_V6";
    case ArgsSchemaType.DATAFRAME_TOOL_SCHEMA_V7:
      return "DATAFRAME_TOOL_SCHEMA_V7";
    case ArgsSchemaType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface DarwinTool {
  /** Header containing metadata */
  header?:
    | DarwinHeader
    | undefined;
  /** Name in Agent */
  agentic_name?:
    | string
    | undefined;
  /** Description in Agent */
  agentic_description?:
    | string
    | undefined;
  /** Type of args schema */
  args_schema_type?:
    | ArgsSchemaType
    | undefined;
  /** JSON schema defining the tool's input arguments */
  args_schema?:
    | string
    | undefined;
  /** Optional Jinja template to build system prompt (skill tool only) */
  template?: string | undefined;
}

/** Model Parameters for Darwin agents */
export interface ModelParameters {
  /** Model provider (e.g., "openai", "anthropic") */
  model_provider?:
    | string
    | undefined;
  /** Model name (e.g., "gpt-4", "claude-3") */
  model_name?:
    | string
    | undefined;
  /** Temperature for generation */
  temperature?:
    | number
    | undefined;
  /** Reasoning effort level */
  reasoning_effort_level?: ReasoningEffortLevel | undefined;
}

export interface PromptProto {
  /** Header containing metadata */
  header?:
    | DarwinHeader
    | undefined;
  /** Model config like provider, name, temperature */
  model_config?:
    | ModelParameters
    | undefined;
  /** Jinja template */
  template?: string | undefined;
}

/** Darwin Agent */
export interface DarwinAgent {
  /** Agent header containing metadata */
  header?:
    | DarwinHeader
    | undefined;
  /** Assigned Prompts list */
  prompts: PromptProto[];
  /** Linked Tools list */
  tools: DarwinTool[];
  /** Optional Jinja2 template resolved into a CONTEXT HumanMessage after the system prompt */
  context_template?:
    | string
    | undefined;
  /** Skills assignable to the agent */
  skills: SkillProto[];
}

/** Skill – a reusable capability loaded at runtime via load_skill(agentic_name). */
export interface SkillProto {
  /** Skill header */
  header?:
    | DarwinHeader
    | undefined;
  /** LLM-facing identifier; argument passed to load_skill() */
  agentic_name?:
    | string
    | undefined;
  /** Versioned Jinja2 templates – exactly one should be active */
  prompts: PromptProto[];
  /** Tools bound to the skill when it is loaded at runtime */
  tools: DarwinTool[];
}

export interface DarwinToolListWrapper {
  /** List of tools matching the request criteria */
  tools: DarwinTool[];
  /** total tools for the response */
  total?: number | undefined;
}

function createBaseDarwinTool(): DarwinTool {
  return {
    header: undefined,
    agentic_name: undefined,
    agentic_description: undefined,
    args_schema_type: undefined,
    args_schema: undefined,
    template: undefined,
  };
}

export const DarwinTool: MessageFns<DarwinTool> = {
  encode(message: DarwinTool, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      DarwinHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.agentic_name !== undefined) {
      writer.uint32(34).string(message.agentic_name);
    }
    if (message.agentic_description !== undefined) {
      writer.uint32(42).string(message.agentic_description);
    }
    if (message.args_schema_type !== undefined) {
      writer.uint32(16).int32(message.args_schema_type);
    }
    if (message.args_schema !== undefined) {
      writer.uint32(26).string(message.args_schema);
    }
    if (message.template !== undefined) {
      writer.uint32(50).string(message.template);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DarwinTool {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDarwinTool();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = DarwinHeader.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.agentic_name = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.agentic_description = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.args_schema_type = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.args_schema = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.template = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DarwinTool {
    return {
      header: isSet(object.header) ? DarwinHeader.fromJSON(object.header) : undefined,
      agentic_name: isSet(object.agentic_name) ? globalThis.String(object.agentic_name) : undefined,
      agentic_description: isSet(object.agentic_description)
        ? globalThis.String(object.agentic_description)
        : undefined,
      args_schema_type: isSet(object.args_schema_type) ? argsSchemaTypeFromJSON(object.args_schema_type) : undefined,
      args_schema: isSet(object.args_schema) ? globalThis.String(object.args_schema) : undefined,
      template: isSet(object.template) ? globalThis.String(object.template) : undefined,
    };
  },

  toJSON(message: DarwinTool): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = DarwinHeader.toJSON(message.header);
    }
    if (message.agentic_name !== undefined) {
      obj.agentic_name = message.agentic_name;
    }
    if (message.agentic_description !== undefined) {
      obj.agentic_description = message.agentic_description;
    }
    if (message.args_schema_type !== undefined) {
      obj.args_schema_type = argsSchemaTypeToJSON(message.args_schema_type);
    }
    if (message.args_schema !== undefined) {
      obj.args_schema = message.args_schema;
    }
    if (message.template !== undefined) {
      obj.template = message.template;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DarwinTool>, I>>(base?: I): DarwinTool {
    return DarwinTool.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DarwinTool>, I>>(object: I): DarwinTool {
    const message = createBaseDarwinTool();
    message.header = (object.header !== undefined && object.header !== null)
      ? DarwinHeader.fromPartial(object.header)
      : undefined;
    message.agentic_name = object.agentic_name ?? undefined;
    message.agentic_description = object.agentic_description ?? undefined;
    message.args_schema_type = object.args_schema_type ?? undefined;
    message.args_schema = object.args_schema ?? undefined;
    message.template = object.template ?? undefined;
    return message;
  },
};

function createBaseModelParameters(): ModelParameters {
  return {
    model_provider: undefined,
    model_name: undefined,
    temperature: undefined,
    reasoning_effort_level: undefined,
  };
}

export const ModelParameters: MessageFns<ModelParameters> = {
  encode(message: ModelParameters, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.model_provider !== undefined) {
      writer.uint32(10).string(message.model_provider);
    }
    if (message.model_name !== undefined) {
      writer.uint32(18).string(message.model_name);
    }
    if (message.temperature !== undefined) {
      writer.uint32(25).double(message.temperature);
    }
    if (message.reasoning_effort_level !== undefined) {
      writer.uint32(32).int32(message.reasoning_effort_level);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ModelParameters {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseModelParameters();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.model_provider = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.model_name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.temperature = reader.double();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.reasoning_effort_level = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ModelParameters {
    return {
      model_provider: isSet(object.model_provider) ? globalThis.String(object.model_provider) : undefined,
      model_name: isSet(object.model_name) ? globalThis.String(object.model_name) : undefined,
      temperature: isSet(object.temperature) ? globalThis.Number(object.temperature) : undefined,
      reasoning_effort_level: isSet(object.reasoning_effort_level)
        ? reasoningEffortLevelFromJSON(object.reasoning_effort_level)
        : undefined,
    };
  },

  toJSON(message: ModelParameters): unknown {
    const obj: any = {};
    if (message.model_provider !== undefined) {
      obj.model_provider = message.model_provider;
    }
    if (message.model_name !== undefined) {
      obj.model_name = message.model_name;
    }
    if (message.temperature !== undefined) {
      obj.temperature = message.temperature;
    }
    if (message.reasoning_effort_level !== undefined) {
      obj.reasoning_effort_level = reasoningEffortLevelToJSON(message.reasoning_effort_level);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ModelParameters>, I>>(base?: I): ModelParameters {
    return ModelParameters.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ModelParameters>, I>>(object: I): ModelParameters {
    const message = createBaseModelParameters();
    message.model_provider = object.model_provider ?? undefined;
    message.model_name = object.model_name ?? undefined;
    message.temperature = object.temperature ?? undefined;
    message.reasoning_effort_level = object.reasoning_effort_level ?? undefined;
    return message;
  },
};

function createBasePromptProto(): PromptProto {
  return { header: undefined, model_config: undefined, template: undefined };
}

export const PromptProto: MessageFns<PromptProto> = {
  encode(message: PromptProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      DarwinHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.model_config !== undefined) {
      ModelParameters.encode(message.model_config, writer.uint32(18).fork()).join();
    }
    if (message.template !== undefined) {
      writer.uint32(26).string(message.template);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PromptProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePromptProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = DarwinHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.model_config = ModelParameters.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.template = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PromptProto {
    return {
      header: isSet(object.header) ? DarwinHeader.fromJSON(object.header) : undefined,
      model_config: isSet(object.model_config) ? ModelParameters.fromJSON(object.model_config) : undefined,
      template: isSet(object.template) ? globalThis.String(object.template) : undefined,
    };
  },

  toJSON(message: PromptProto): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = DarwinHeader.toJSON(message.header);
    }
    if (message.model_config !== undefined) {
      obj.model_config = ModelParameters.toJSON(message.model_config);
    }
    if (message.template !== undefined) {
      obj.template = message.template;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PromptProto>, I>>(base?: I): PromptProto {
    return PromptProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PromptProto>, I>>(object: I): PromptProto {
    const message = createBasePromptProto();
    message.header = (object.header !== undefined && object.header !== null)
      ? DarwinHeader.fromPartial(object.header)
      : undefined;
    message.model_config = (object.model_config !== undefined && object.model_config !== null)
      ? ModelParameters.fromPartial(object.model_config)
      : undefined;
    message.template = object.template ?? undefined;
    return message;
  },
};

function createBaseDarwinAgent(): DarwinAgent {
  return { header: undefined, prompts: [], tools: [], context_template: undefined, skills: [] };
}

export const DarwinAgent: MessageFns<DarwinAgent> = {
  encode(message: DarwinAgent, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      DarwinHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    for (const v of message.prompts) {
      PromptProto.encode(v!, writer.uint32(18).fork()).join();
    }
    for (const v of message.tools) {
      DarwinTool.encode(v!, writer.uint32(26).fork()).join();
    }
    if (message.context_template !== undefined) {
      writer.uint32(34).string(message.context_template);
    }
    for (const v of message.skills) {
      SkillProto.encode(v!, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DarwinAgent {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDarwinAgent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = DarwinHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.prompts.push(PromptProto.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.tools.push(DarwinTool.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.context_template = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.skills.push(SkillProto.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DarwinAgent {
    return {
      header: isSet(object.header) ? DarwinHeader.fromJSON(object.header) : undefined,
      prompts: globalThis.Array.isArray(object?.prompts) ? object.prompts.map((e: any) => PromptProto.fromJSON(e)) : [],
      tools: globalThis.Array.isArray(object?.tools) ? object.tools.map((e: any) => DarwinTool.fromJSON(e)) : [],
      context_template: isSet(object.context_template) ? globalThis.String(object.context_template) : undefined,
      skills: globalThis.Array.isArray(object?.skills) ? object.skills.map((e: any) => SkillProto.fromJSON(e)) : [],
    };
  },

  toJSON(message: DarwinAgent): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = DarwinHeader.toJSON(message.header);
    }
    if (message.prompts?.length) {
      obj.prompts = message.prompts.map((e) => PromptProto.toJSON(e));
    }
    if (message.tools?.length) {
      obj.tools = message.tools.map((e) => DarwinTool.toJSON(e));
    }
    if (message.context_template !== undefined) {
      obj.context_template = message.context_template;
    }
    if (message.skills?.length) {
      obj.skills = message.skills.map((e) => SkillProto.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DarwinAgent>, I>>(base?: I): DarwinAgent {
    return DarwinAgent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DarwinAgent>, I>>(object: I): DarwinAgent {
    const message = createBaseDarwinAgent();
    message.header = (object.header !== undefined && object.header !== null)
      ? DarwinHeader.fromPartial(object.header)
      : undefined;
    message.prompts = object.prompts?.map((e) => PromptProto.fromPartial(e)) || [];
    message.tools = object.tools?.map((e) => DarwinTool.fromPartial(e)) || [];
    message.context_template = object.context_template ?? undefined;
    message.skills = object.skills?.map((e) => SkillProto.fromPartial(e)) || [];
    return message;
  },
};

function createBaseSkillProto(): SkillProto {
  return { header: undefined, agentic_name: undefined, prompts: [], tools: [] };
}

export const SkillProto: MessageFns<SkillProto> = {
  encode(message: SkillProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      DarwinHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.agentic_name !== undefined) {
      writer.uint32(18).string(message.agentic_name);
    }
    for (const v of message.prompts) {
      PromptProto.encode(v!, writer.uint32(26).fork()).join();
    }
    for (const v of message.tools) {
      DarwinTool.encode(v!, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SkillProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSkillProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = DarwinHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.agentic_name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.prompts.push(PromptProto.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.tools.push(DarwinTool.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SkillProto {
    return {
      header: isSet(object.header) ? DarwinHeader.fromJSON(object.header) : undefined,
      agentic_name: isSet(object.agentic_name) ? globalThis.String(object.agentic_name) : undefined,
      prompts: globalThis.Array.isArray(object?.prompts) ? object.prompts.map((e: any) => PromptProto.fromJSON(e)) : [],
      tools: globalThis.Array.isArray(object?.tools) ? object.tools.map((e: any) => DarwinTool.fromJSON(e)) : [],
    };
  },

  toJSON(message: SkillProto): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = DarwinHeader.toJSON(message.header);
    }
    if (message.agentic_name !== undefined) {
      obj.agentic_name = message.agentic_name;
    }
    if (message.prompts?.length) {
      obj.prompts = message.prompts.map((e) => PromptProto.toJSON(e));
    }
    if (message.tools?.length) {
      obj.tools = message.tools.map((e) => DarwinTool.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SkillProto>, I>>(base?: I): SkillProto {
    return SkillProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SkillProto>, I>>(object: I): SkillProto {
    const message = createBaseSkillProto();
    message.header = (object.header !== undefined && object.header !== null)
      ? DarwinHeader.fromPartial(object.header)
      : undefined;
    message.agentic_name = object.agentic_name ?? undefined;
    message.prompts = object.prompts?.map((e) => PromptProto.fromPartial(e)) || [];
    message.tools = object.tools?.map((e) => DarwinTool.fromPartial(e)) || [];
    return message;
  },
};

function createBaseDarwinToolListWrapper(): DarwinToolListWrapper {
  return { tools: [], total: undefined };
}

export const DarwinToolListWrapper: MessageFns<DarwinToolListWrapper> = {
  encode(message: DarwinToolListWrapper, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.tools) {
      DarwinTool.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.total !== undefined) {
      writer.uint32(16).int32(message.total);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DarwinToolListWrapper {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDarwinToolListWrapper();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.tools.push(DarwinTool.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.total = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DarwinToolListWrapper {
    return {
      tools: globalThis.Array.isArray(object?.tools) ? object.tools.map((e: any) => DarwinTool.fromJSON(e)) : [],
      total: isSet(object.total) ? globalThis.Number(object.total) : undefined,
    };
  },

  toJSON(message: DarwinToolListWrapper): unknown {
    const obj: any = {};
    if (message.tools?.length) {
      obj.tools = message.tools.map((e) => DarwinTool.toJSON(e));
    }
    if (message.total !== undefined) {
      obj.total = Math.round(message.total);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DarwinToolListWrapper>, I>>(base?: I): DarwinToolListWrapper {
    return DarwinToolListWrapper.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DarwinToolListWrapper>, I>>(object: I): DarwinToolListWrapper {
    const message = createBaseDarwinToolListWrapper();
    message.tools = object.tools?.map((e) => DarwinTool.fromPartial(e)) || [];
    message.total = object.total ?? undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
